import { createHandlerChainRunner, executeAwaitableHandlerChain, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import CustomCartLoadProducts from "@tSurya/Handlers/CustomCartLoadProducts";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

interface Props{
    product?: ProductCollectionModel;
    categoryId?: string;
    result?: ProductModel[];
    isOutDoor?: boolean;
}

type RugPadDetailsParam = HasOnSuccess<ProductModel[]> & Props & HasOnError;

type HandlerType = CustomApiHandler<RugPadDetailsParam, ProductModel[]>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const GetProductData: HandlerType = async props => {
    if (props.apiParameter.categoryId) {
        props.apiParameter.product=  await executeAwaitableHandlerChain(CustomCartLoadProducts,{
            pageSize: 24,
            categoryId: props.apiParameter.categoryId,
            expand: ["attributes", "facets", "variantTraits", "properties", "badges"],
            includeAttributes: ["includeOnProduct"],
            includeSuggestions: true,},props);
}}
export const SortProductData: HandlerType = props => {
    const outdoorRugPads = siteMessage("OutdoorRugPad").toString().split(";").map(t => t.trim());
    const rugPads = siteMessage("RugPad").toString().split(";").map(t => t.trim());
    if(props.apiParameter.product?.products){
    if (props.apiParameter.isOutDoor) {
        props.apiResult = props.apiParameter.product.products.filter(p => outdoorRugPads.includes(p.productTitle));
    } else {
        props.apiResult = props.apiParameter.product.products.filter(p => rugPads.includes(p.productTitle));
    }
}
}
export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [PopulateApiParameter,GetProductData,SortProductData, ExecuteOnSuccessCallback];

const getRugPads = createHandlerChainRunner(chain, "getRugPadAvailableSizes");
export default getRugPads;